import React from 'react';
import Post from './Post';
import { Link } from 'react-router-dom';

const PostList = ({posts, auth, showOnlyYourPost}) => {
    return (
        <div className="post-list section">
            { posts && posts.filter(post => {
                const userPost = post.authorId === auth.uid ? post : post.activated;

                if(showOnlyYourPost) {
                    return userPost.authorId === auth.uid ? userPost : null;
                }
                else {
                    return userPost;
                }
            }).map(post => {
                return (
                    <Link to={'/post/' + post.id} key={post.id}>
                        <Post post={post} uid={auth.uid}/>
                    </Link>
                )
            })}
        </div>
    )
}

export default PostList;